export default "__VITE_PUBLIC_ASSET__d05b292c__"